<template lang="pug">
.container.grid-lg.py-2
  .no-print
    form-filter(
      @submit="onFilter",
      :auto-filter="autoFilter",
      :default-query="q",
      filter-key="docs-por-irregularidade"
    )

  load-manager(:status="status")
    list-manager(:status="status", :count="list.length")
      table.table.table-striped.table-sm
        thead
          tr
            th {{ "doc.numero" | tModel }}/{{ "doc.ano" | tModel }}
            th {{ "doc.modelo" | tModel }}
            th {{ "doc.irregularidades" | tModel }}
            th {{ "doc.cadastro" | tModel }}
            th {{ "doc.ciencia_em" | tModel }}
            th {{ "doc.situacao" | tModel }}
            th.text-right {{ "doc.valor_total" | tModel }}
            th.actions-col
        tbody
          tr(v-for="doc in list")
            td {{ doc.numero }}/{{ doc.ano }}
            td {{ doc.modelo.descricao }}
            td(v-if="doc.irregularidades && doc.irregularidades.length")
              ul.docs-irregularidades
                li.text-small(v-for="i in doc.irregularidades") {{ i.descricao }}
            td(v-else) -
            td {{ doc.cadastro.numero }}
            td {{ doc.ciencia_em | date }}
            td {{ doc.situacao.descricao }}
            td.text-right {{ doc.valor_total | currency("R$ ") }}
            td.actions-col
              router-link.btn.btn-link.tooltip.tooltip-left(
                :data-tooltip="'views.buttons.show.label' | translate",
                :to="{ name: 'fiscalizacao.docs.show', params: { id: doc.id } }"
              )
                btn-icon(name="show")
              a.btn.btn-action.btn-sm.btn-link.tooltip.tooltip-left(
                :href="doc.url",
                target="_blank",
                data-tooltip="Imprimir"
              )
                btn-icon(name="print")
      .my-2.text-right(v-if="pages > 1")
        btn-paginate(
          :page="page",
          :pages="pages",
          :count="count",
          @go-page="goPage",
          @prev-page="prevPage",
          @next-page="nextPage"
        )
</template>

<script>
import { vuexDefaultMapping } from "@/mixins/list"
import FormFilter from "./Filter"

export default {
  vuex: {
    "consulta/docsPorIrregularidade": vuexDefaultMapping,
  },

  components: { FormFilter },

  data() {
    return { q: { id_order_by: "desc" } }
  },

  methods: {
    onFilter(q = {}) {
      this.q = { ...q }
      this.setQuery({ ...q })
      this.setPage(1)
      this.fetchList()
    },
  },

  computed: {
    autoFilter() {
      return !this.list || this.list.length === 0
    },
  },

  created() {
    this.q = { ...this.q, ...this.query }
  },
}
</script>

<style lang="stylus" scoped>
.docs-irregularidades {
  padding: 0;
  margin: 0;

  li {
    margin-top: 0.1rem;
  }
}
</style>
